





















































import Vue from 'vue'
import FullModalLayout from '@/components/modal/basics/FullModal/FullModalLayout.vue'
import FullModalHeaderCloseButton from '@/components/modal/basics/FullModal/FullModalHeader/FullModalHeaderCloseButton.vue'
import FullModalHeaderTitle from '@/components/modal/basics/FullModal/FullModalHeader/FullModalHeaderTitle.vue'
import SelectButton from '@/components/modal/basics/SelectButton.vue'

export interface Option {
  label: string
  value: number
}

export default Vue.extend({
  components: {
    FullModalLayout,
    FullModalHeaderCloseButton,
    FullModalHeaderTitle,
    SelectButton,
  },
  props: {
    title: {
      type: String as () => string,
      required: true,
    },
    name: {
      type: String as () => string,
      default: 'MultiSelectModal',
    },
    options: {
      type: Array as () => Option[],
      default: [],
    },
    values: {
      type: Array as () => Option['value'][],
      default: [],
    },
  },
  data() {
    return {
      innerValues: [] as Option['value'][],
    }
  },
  methods: {
    setValues(values: Option['value'][]) {
      this.innerValues = values
    },
    isChecked(value: Option['value']) {
      return this.innerValues.includes(value)
    },
    beforeOpen(): void {
      if (this.values) {
        this.innerValues = this.values
      }
    },
    getCheckIcon(checked: boolean): string {
      return checked ? 'checkbox' : 'checkbox_null'
    },
    handleSubmit() {
      this.$emit('onSubmit', this.innerValues)
      this.$modal.pop()
    },
  },
})
